import { ReduxAction } from '../core';

export class UIAction {
  public static SHOW_SIDE_PANEL = `UI_SHOW_SIDE_PANEL`;
  public static HIDE_SIDE_PANEL = `UI_HIDE_SIDE_PANEL`;
  public static SET_EXPAND_NAV = `UI_SET_EXPAND_NAV`;

  public static SET_DATE = `UI_SET_DATE`;
  public static SET_MARKETS = `UI_SET_MARKETS`;
  public static SET_SERVICES = `UI_SET_SERVICES`;
  public static SET_VISIT_CODE = `UI_SET_VISIT_CODE`;
  public static SET_VISIT_STATUS = `UI_SET_VISIT_STATUS`;
  public static SET_VISIT_FILTER_TEXT = `UI_SET_VISIT_FILTER_TEXT`;
  public static SET_PARTNER_FILTER_TEXT = `UI_SET_PARTNER_FILTER_TEXT`;
  public static SET_PROVIDER_ID = `UI_SET_PROVIDER_ID`;

  public static SET_CLAIMS_STATUS = `UI_SET_CLAIMS_STATUS`;
  public static SET_CLAIMS_FROM_DATE = `UI_SET_CLAIMS_FROM_DATE`;
  public static SET_CLAIMS_TO_DATE = `UI_SET_CLAIMS_TO_DATE`;
  public static SET_CLAIMS_SEARCH_TEXT = `UI_SET_CLAIMS_SEARCH_TEXT`;

  public static SET_ONSITES_FROM_DATE = `UI_SET_ONSITES_FROM_DATE`;
  public static SET_ONSITES_TO_DATE = `UI_SET_ONSITES_TO_DATE`;
  public static SET_ONSITES_VISIT_FILTER_TEXT = `UI_SET_ONSITES_VISIT_FILTER_TEXT`;
  public static SET_ONSITE_EVENTS_FILTER_TEXT = `UI_SET_ONSITE_EVENTS_FILTER_TEXT`;

  public static SET_ONSITE_MANAGER_ACTIVE_KEY = `UI_SET_ONSITE_MANAGER_ACTIVE_KEY`;
  public static SET_ONSITE_EVENT_ACTIVE_KEY = `UI_SET_ONSITE_EVENT_ACTIVE_KEY`;
  public static SET_PARTNER_ACTIVE_KEY = `UI_SET_PARTNER_ACTIVE_KEY`;

  public static KEY_STATE_CHANGE = `UI_KEY_STATE_CHANGE`;

  public static SET_SHOW_PAIRING_RULES = `SET_SHOW_PAIRING_RULES`;
  public static SET_SCHEDULING_EXPANDED_GROUPS = `SET_SCHEDULING_EXPANDED_GROUPS`;
  public static SET_COLLAPSIBLE_SECTIONS_CLOSED = `SET_COLLAPSIBLE_SECTIONS_CLOSED`;
  public static SET_LAST_MAP_LOCATION = `UI_SET_LAST_MAP_LOCATION`;
}

export function showSidePanel(): ReduxAction<string> {
  return {
    type: UIAction.SHOW_SIDE_PANEL,
    data: '',
  };
}

export function hideSidePanel(): ReduxAction<string> {
  return {
    type: UIAction.HIDE_SIDE_PANEL,
    data: '',
  };
}

export function setExpandNav(expanded: boolean): ReduxAction<boolean> {
  return {
    type: UIAction.SET_EXPAND_NAV,
    data: expanded,
  };
}

export function setDate(data: string): ReduxAction<string> {
  return {
    type: UIAction.SET_DATE,
    data,
  };
}

export function setMarkets(data: string[]): ReduxAction<string[]> {
  return {
    type: UIAction.SET_MARKETS,
    data,
  };
}

export function setServices(data: string[]): ReduxAction<string[]> {
  return {
    type: UIAction.SET_SERVICES,
    data,
  };
}

export function setVisitCode(data: string): ReduxAction<string> {
  return {
    type: UIAction.SET_VISIT_CODE,
    data,
  };
}

export function setVisitStatus(data: string): ReduxAction<string> {
  return {
    type: UIAction.SET_VISIT_STATUS,
    data,
  };
}

export function setVisitFilterText(data: string): ReduxAction<string> {
  return {
    type: UIAction.SET_VISIT_FILTER_TEXT,
    data,
  };
}

export function setPartnerFilterText(data: string): ReduxAction<string> {
  return {
    type: UIAction.SET_PARTNER_FILTER_TEXT,
    data,
  };
}

export function setProvider(data: string): ReduxAction<string> {
  return {
    type: UIAction.SET_PROVIDER_ID,
    data,
  };
}

export function setClaimStatus(data: string[]): ReduxAction<string[]> {
  return {
    type: UIAction.SET_CLAIMS_STATUS,
    data,
  };
}

export function setClaimsSearchText(data: string): ReduxAction<string> {
  return {
    type: UIAction.SET_CLAIMS_SEARCH_TEXT,
    data,
  };
}

export function setClaimsFromDate(data: string): ReduxAction<string> {
  return {
    type: UIAction.SET_CLAIMS_FROM_DATE,
    data,
  };
}

export function setClaimsToDate(data: string): ReduxAction<string> {
  return {
    type: UIAction.SET_CLAIMS_TO_DATE,
    data,
  };
}

export function setOnSiteFromDate(data: string): ReduxAction<string> {
  return {
    type: UIAction.SET_ONSITES_FROM_DATE,
    data,
  };
}

export function setOnSiteToDate(data: string): ReduxAction<string> {
  return {
    type: UIAction.SET_ONSITES_TO_DATE,
    data,
  };
}

export function setOnSiteVisitFilterText(data: string): ReduxAction<string> {
  return {
    type: UIAction.SET_ONSITES_VISIT_FILTER_TEXT,
    data,
  };
}

export function setOnSiteEventsFilterText(data: string): ReduxAction<string> {
  return {
    type: UIAction.SET_ONSITE_EVENTS_FILTER_TEXT,
    data,
  };
}

export function setOnSiteManagerActiveKey(data: string): ReduxAction<string> {
  return {
    type: UIAction.SET_ONSITE_MANAGER_ACTIVE_KEY,
    data,
  };
}

export function setOnSiteEventActiveKey(data: string): ReduxAction<string> {
  return {
    type: UIAction.SET_ONSITE_EVENT_ACTIVE_KEY,
    data,
  };
}

export function setPartnerActiveKey(data: string): ReduxAction<string> {
  return {
    type: UIAction.SET_PARTNER_ACTIVE_KEY,
    data,
  };
}

export function keyStateChange(keyCode: number, pressed: boolean): ReduxAction<{ keyCode: number; pressed: boolean }> {
  return {
    type: UIAction.KEY_STATE_CHANGE,
    data: {
      keyCode: keyCode,
      pressed: pressed,
    },
  };
}

export function setShowPairingRules(show: boolean): ReduxAction<boolean> {
  return {
    type: UIAction.SET_SHOW_PAIRING_RULES,
    data: show,
  };
}

export function setSchedulingExpandedGroups(data: string[]): ReduxAction<string[]> {
  return {
    type: UIAction.SET_SCHEDULING_EXPANDED_GROUPS,
    data,
  };
}

export function setCollapsibleSectionClosed(data: string[]): ReduxAction<string[]> {
  return {
    type: UIAction.SET_COLLAPSIBLE_SECTIONS_CLOSED,
    data,
  };
}

export function setLastMapLocation(data: { lat: number; lng: number }): ReduxAction<{ lat: number; lng: number }> {
  return {
    type: UIAction.SET_LAST_MAP_LOCATION,
    data,
  };
}
